import { ProfileAvatar } from '@care/react-component-lib';
import { Icon48DaycareCenters } from '@care/react-embrace-icons';
import { useResponsive } from '@/components/hooks/useResponsive';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults_seoSegmentationProvider as SEOSegmentationProvider } from '@/__generated__/seoSegmentationListingPage';

export interface SMBProfileAvatarProps {
  provider: SEOSegmentationProvider;
  isClientSearchResultsQuery: boolean;
}

export const SMBProfileAvatar = ({
  provider: seoSegmentationProvider,
  isClientSearchResultsQuery,
}: SMBProfileAvatarProps) => {
  const { isSmallViewport } = useResponsive();

  const profileAvatarProps = {
    alt: `${seoSegmentationProvider.provider.name}'s Photo`,
    size: isSmallViewport ? 'squareSmall' : 'squareLarge',
    src: seoSegmentationProvider.provider.logo?.urlThumbnail ?? undefined,
    className: !isSmallViewport ? 'seo-smb-avatar' : undefined,
    slotProps: {
      avatar: {
        imgProps: isClientSearchResultsQuery
          ? { loading: 'eager' as const }
          : { loading: 'lazy' as const },
      },
    },
  } as const;

  return (
    <ProfileAvatar
      {...profileAvatarProps}
      sx={{
        '&.seo-smb-avatar .MuiAvatar-root': {
          width: '240px',
        },
      }}>
      <Icon48DaycareCenters />
    </ProfileAvatar>
  );
};
